// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/status","name":"status","icon":"solution","parentId":"ant-design-pro-layout","id":"1"},"2":{"path":"/user","layout":false,"id":"2"},"3":{"name":"login","path":"/user/login","parentId":"2","id":"3"},"4":{"name":"wecom-login","path":"/user/wecom-login","layout":false,"parentId":"2","id":"4"},"5":{"path":"/welcome","name":"welcome","icon":"smile","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/home","redirect":"/status","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/","redirect":"/status","parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"*","layout":false,"id":"8"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__dashboard__index" */'@/pages/dashboard/index.tsx')),
'2': React.lazy(() => import('./EmptyRoute')),
'3': React.lazy(() => import(/* webpackChunkName: "p__user__web-login__index" */'@/pages/user/web-login/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__user__wecom-login__index" */'@/pages/user/wecom-login/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__Welcome" */'@/pages/Welcome.tsx')),
'6': React.lazy(() => import('./EmptyRoute')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/root/agent/work/cc3543e1b1464b4f/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
